import { Flex, Text } from '@mantine/core';
import { DangerouslySetInnerHTML } from '@shared/ui';

type VacancyItemPointProps = {
  subTitle?: string;
  title?: string;
  points: string;
};

export const VacancyItemPoint = ({
  title,
  subTitle,
  points,
}: VacancyItemPointProps) => {
  return (
    <Flex rowGap={8} direction='column'>
      <Text size='sm' c='tertiary.7'>
        {subTitle}
      </Text>

      {title && (
        <Text c='primary.7' fw={600} mb={16}>
          {title}:
        </Text>
      )}

      <DangerouslySetInnerHTML __html={points} />
    </Flex>
  );
};
